import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Logo } from 'settings';
import './Menu.scss';
import './MenuLogo.scss';

const Menu = (props) => {
  return (
    // <nav className={`menu ${props.className} ${props.inverted ? 'menu--inverted' : ''}  ${props.split ? 'menu--split' : ''}`}>
    <nav className={`menu ${props.className}`}>
      <Link to={props.rootUrl} className="menu__logo">
        <props.logo />
      </Link>
      {props.children}
    </nav>
  );
};

Menu.propTypes = {
  className: PropTypes.string,
  // logo: PropTypes.node.isRequired, // shoudl be around width="83" and exact height="28"
};

Menu.defaultProps = {
  className: '',
  rootUrl: '/',
  logo: Logo,
};

export default Menu;
